import React from 'react';
import s from './OneLessonElement.module.css';
import arrow from '../../../assets/img/icons/Lessons/material-symbols_play-arrow.svg';

type Props = {
	setOpen?: (b: boolean) => void;
	open: boolean;
	title: string;
};

const LessonAccordionTopComponent: React.FC<Props> = ({
	title,
	open,
	setOpen,
}) => {
	return (
		<div
			role="button"
			tabIndex={0}
			className={s.lessonTop}
			onClick={() => setOpen && setOpen(!open)}
		>
			<div>
				<img
					src={arrow}
					alt="arrow"
					style={{transform: !open ? 'rotate(180deg)' : ''}}
				/>
			</div>
			<div className={s.lessonName}>{title}</div>
		</div>
	);
};

export default LessonAccordionTopComponent;
